module.exports = __webpack_public_path__ + "assets/img/lightbox-active.e7546791.svg";